import React, { Fragment } from "react";
import { connect } from "react-redux";
import S from "sanctuary";

import {
  mapStateToProps,
  mapDispatchToProps,
} from "./TransactionSearchResults.state";
import TransactionsTable from "./TransactionsTable";
import {
  TransactionSearchResultsContent,
  ResultsCountText,
} from "./TractionSearchResults.styled";

import { ScrollArea } from "@/components/generic/PageLayout";
import { NARROW_SCREEN } from "@/constants/layout";
import Pagination from "@/components/pagination";
import {
  Module,
  Box,
  NoResultsIcon,
  PaymentSearchIcon,
  Paragraph,
  Heading,
  Center,
  constants,
} from "@thecb/components";

const EMPTY_STATE_STYLES = `
  svg {
    max-width: 100%;
    height: auto;
  }

  ${NARROW_SCREEN} {
    padding: 32px 24px;
  }
`;

const TransactionSearchResults = ({
  transactions,
  searchResultsPageCount,
  currentPage,
  setCurrentPage,
  pageNext,
  pagePrevious,
  openTransactionDetails,
  searchRequestPending,
  searchRequestError,
  userTimezone,
  totalSearchResultsCount,
  searchPendingText,
  dateFilter,
}) => {
  return (
    <Fragment>
      <ResultsCountText>
        {S.isJust(transactions) &&
          !searchRequestPending &&
          `${totalSearchResultsCount} Result${
            totalSearchResultsCount === 1 ? "" : "s"
          }`}
        {searchRequestPending && searchPendingText}
      </ResultsCountText>
      <Box padding="0" width="100%">
        <Module spacingBottom="0">
          <TransactionSearchResultsContent>
            <ScrollArea>
              <TransactionsTable
                dateFilter={dateFilter}
                transactions={S.fromMaybe([])(transactions)}
                isLoading={searchRequestPending}
                openTransactionDetails={openTransactionDetails}
                userTimezone={userTimezone}
              />
            </ScrollArea>
            {S.isNothing(transactions) &&
              !searchRequestPending &&
              S.isNothing(searchRequestError) && (
                <Box padding="64px" minWidth="100%" extraStyles={EMPTY_STATE_STYLES}>
                  <Center intrinsic>
                    <PaymentSearchIcon
                      fillPrimary={constants.colors.LUCKY_POINT}
                      fillSecondary={constants.colors.HAWKES_BLUE}
                    />
                    <Heading variant="h3" weight="700">
                      Perform a Search
                    </Heading>
                    <Paragraph variant="p" extraStyles={`text-align: center;`}>
                      Please perform a search in the search <br /> bar above to see
                      payments.
                    </Paragraph>
                  </Center>
                </Box>
              )}
            {S.isJust(transactions) &&
              !searchRequestPending &&
              S.isNothing(searchRequestError) &&
              S.equals([])(transactions.value) && (
                <Box padding="64px" minWidth="100%" extraStyles={EMPTY_STATE_STYLES}>
                  <Center intrinsic>
                    <NoResultsIcon
                      fillPrimary={constants.colors.LUCKY_POINT}
                      fillSecondary={constants.colors.HAWKES_BLUE}
                    />
                    <Heading variant="h3" weight="700">
                      No Results Found
                    </Heading>
                    <Paragraph variant="p" extraStyles={`text-align: center;`}>
                      We couldn&apos;t find anything that matched your search. <br />
                      Please edit your search and try again.
                    </Paragraph>
                  </Center>
                </Box>
              )}
            {S.isJust(searchRequestError) && (
              <Box padding="64px" minWidth="100%" extraStyles={EMPTY_STATE_STYLES}>
                <Center intrinsic>
                  <NoResultsIcon
                    fillPrimary={constants.colors.LUCKY_POINT}
                    fillSecondary={constants.colors.HAWKES_BLUE}
                  />
                  <Heading variant="h3" weight="700">
                    No Results Found
                  </Heading>
                  <Paragraph variant="p" extraStyles={`text-align: center;`}>
                    Something went wrong, please try your search again.
                    <br />
                    If the problem persists, please contact your administrator.
                  </Paragraph>
                </Center>
              </Box>
            )}
          </TransactionSearchResultsContent>
        </Module>
      </Box>
      {searchResultsPageCount > 1 && (
        <Box padding="0" minWidth="100%">
          <Module padding="24px" spacingBottom="0">
            <Pagination
              pagePrevious={pagePrevious}
              pageNext={pageNext}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              pageCount={searchResultsPageCount}
            />
          </Module>
        </Box>
      )}
    </Fragment>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionSearchResults);
